// Global 401 interceptor: any fetch (from api.ts or a page's own fetch call)
// that comes back unauthenticated sends the browser to the login screen
// instead of leaving a raw JSON error on the page — the PWA dead-end this
// auth track exists to fix. Exempts the auth endpoints themselves, since a
// 401 there means "wrong password"/"wrong code", not "your session died".
const AUTH_ENDPOINT_PREFIXES = ['/api/auth/login', '/api/auth/mfa/', '/api/auth/oauth/'];

function requestPath(input: RequestInfo | URL): string {
  const url = typeof input === 'string' ? input : input instanceof URL ? input.toString() : input.url;
  try {
    return new URL(url, window.location.origin).pathname;
  } catch {
    return url;
  }
}

export function installAuthInterceptor(): void {
  const originalFetch = window.fetch.bind(window);
  window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    const res = await originalFetch(input, init);
    if (res.status === 401) {
      const path = requestPath(input);
      const exempt = AUTH_ENDPOINT_PREFIXES.some((p) => path.startsWith(p));
      if (!exempt && window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return res;
  };
}
